import { SxProps } from '@mui/material';
import { RuleOperationType, RuleTypes } from '@src/api';
import { IntersectionType } from '@src/api/types';
import { theme } from '@src/theme';

export const getLines = (rule: any, disabled: boolean, index?: number, arr?: any[], heightRule?: number) => {
  if (index === undefined || !arr) return { operationType: '', sx: {} };

  const operationType =
    (index > 0 && arr[index - 1]?.nextOperation === RuleOperationType.Or) ||
    rule?.nextOperation === RuleOperationType.Or
      ? RuleOperationType.Or
      : RuleOperationType.And;

  const prevOperationIsOr = index > 0 && arr[index - 1]?.nextOperation === RuleOperationType.Or;

  const halfLengthRule = (heightRule || 0) / 2 + 1;
  const lineBottom = rule?.nextOperation === RuleOperationType.Or;

  const lineAllRule = lineBottom && prevOperationIsOr;

  const lineTop = operationType === RuleOperationType.Or && prevOperationIsOr;

  const heightLine = () => {
    if (lineAllRule) {
      return '100%';
    } else if (lineTop) {
      return `${halfLengthRule}px`;
    } else {
      return `${halfLengthRule + (disabled ? 0 : 48)}px`;
    }
  };
  const sx: SxProps =
    lineAllRule || lineTop || lineBottom
      ? {
          '&:before': {
            content: '""',
            position: 'absolute',
            background: disabled ? theme.palette.secondary['600'] : theme.palette.secondary.main,
            borderRadius: '2px',
            height: `${heightLine()}`,
            width: '2px',
            top: lineAllRule || lineTop ? 0 : `${halfLengthRule}px`,
            left: '-12px',
          },
        }
      : {};

  return { operationType, sx };
};

export const getCriteriasBodyForQuery = (
  criterias?: { criteriaRuleType?: string; nextOperation?: string | null }[] | null,
) => {
  if (!criterias) return null;
  const result: any = { rule: { criteriaRuleType: RuleTypes.CriteriaRuleGroup, operationType: '', rules: [] } };

  if (criterias.length === 1) {
    result.rule = criterias[0];
    return result;
  }

  if (criterias.some(criteria => criteria.nextOperation === RuleOperationType.And)) {
    result.rule.operationType = RuleOperationType.And;

    criterias.forEach((critariaForm, index, arr) => {
      const { nextOperation, ...criteria } = critariaForm;
      const operationType =
        (index > 0 && arr[index - 1]?.nextOperation === RuleOperationType.Or) || nextOperation === RuleOperationType.Or
          ? RuleOperationType.Or
          : RuleOperationType.And;

      const prevOperationIsOr = index > 0 && arr[index - 1]?.nextOperation === RuleOperationType.Or;

      if (operationType === RuleOperationType.Or) {
        if (prevOperationIsOr) {
          result.rule?.rules.at(-1)?.rules.push({
            ...criteria,
          });
        } else {
          result.rule.rules.push({
            criteriaRuleType: RuleTypes.CriteriaRuleGroup,
            operationType: RuleOperationType.Or,
            rules: [{ ...criteria }],
          });
        }
      } else {
        result.rule.rules.push({ ...criteria });
      }
    });
  } else {
    result.rule.operationType = RuleOperationType.Or;
    result.rule.rules.push(...criterias.map(({ nextOperation, ...criteria }) => ({ ...criteria })));
  }
  return result;
};

export const getVisibilityBody = (isEdit, visibilityObject) => {
  const {
    laboratoryIntersectionType,
    laboratoryIds,
    facilityIntersectionType,
    facilityVisibilities,
    salesRepresentativeId,
  } = visibilityObject;

  const result = {
    laboratoryIntersectionType: laboratoryIntersectionType || IntersectionType.None,
    laboratoryIds,
    facilityIntersectionType: facilityIntersectionType || IntersectionType.None,
    facilityVisibilities,
    [isEdit ? 'newSalesRepresentativeId' : 'salesRepresentativeId']: salesRepresentativeId || null,
    ...(isEdit
      ? {
          addedLaboratoryIds: visibilityObject.addedLaboratoryIds || undefined,
          removedLaboratoryIds: visibilityObject.removedLaboratoryIds || undefined,
          addedFacilityVisibilities: visibilityObject.addedFacilityVisibilities || undefined,
          removedFacilityVisibilities: visibilityObject.removedFacilityVisibilities || undefined,
        }
      : {}),
  };
  const allEmpty = Object.values(result).every(val => !val);
  return allEmpty ? null : result;
};
